export default __webpack_public_path__ + "static/media/Viki.1ba33519.png";